<template>
  <div class="card mt-4">
    <div class="card-header">
      <h5>Assign Serial Numbers & Images</h5>
    </div>
    <div class="card-body">
      <div class="mb-3">
        <label>Select Product</label>
        <select class="form-control" v-model="selectedProductId" @change="loadUnassignedUnits">
          <option disabled value="">-- Select Product --</option>
          <option v-for="product in products" :key="product.id" :value="product.id">
            {{ product.name }}
          </option>
        </select>
      </div>

      <div v-if="units.length">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Unit ID</th>
              <th>Serial Number</th>
              <!-- <th>Images</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(unit, index) in units" :key="unit.id">
              <td>{{ index + 1 }}</td>
              <td>{{ unit.id }}</td>
              <td>
                <input type="text" class="form-control" v-model="unit.serialNumber" placeholder="Enter serial number" />
              </td>
              <!-- <td>
                <input type="file" multiple @change="handleImageChange(index, $event)" class="form-control" />
                <div class="image-preview mt-2 d-flex flex-wrap gap-2">
                  <div v-for="(image, imgIndex) in unit.images" :key="imgIndex" class="image-thumbnail-container position-relative">
                    <img :src="image.preview" class="img-thumbnail" alt="Product Image" style="width: 100px; height: 100px; object-fit: cover;" />
                    <button @click="removeImage(index, imgIndex)" class="btn btn-danger btn-sm position-absolute top-0 end-0 m-1">
                      &times;
                    </button>
                  </div>
                </div>
              </td> -->
            </tr>
          </tbody>
        </table>

        <div class="text-end">
          <button class="btn btn-success" @click="submitSerials">Submit</button>
        </div>
      </div>

      <div v-else-if="selectedProductId" class="text-muted text-center">
        No unassigned units for selected product.
      </div>
      <div v-else class="text-muted text-center">
        Please select a product to see unassigned units.
      </div>
    </div>
  </div>
</template>

<script>
import { productApi } from "@/api/productApi";
import notify from "@/utils/swal.js";

export default {
  data() {
    return {
      products: [],
      selectedProductId: '',
      units: []
    };
  },
  async created() {
    try {
      this.products = (await productApi.getProductsWithUnassignedUnits()).data;
    } catch (err) {
      console.error("Failed to load product list:", err);
      notify.error("Failed to load product list.");
    }
  },

  methods: {
    async loadUnassignedUnits() {
      if (!this.selectedProductId) {
        this.units = [];
        return;
      }
      try {
        const res = await productApi.getUnassignedUnits(this.selectedProductId);
        this.units = res.data.map(u => ({ ...u, serialNumber: '', images: [] }));
      } catch (err) {
        notify.error("Failed to load units.");
        console.error(err);
      }
    },

    handleImageChange(unitIndex, event) {
      const files = event.target.files;
      if (files) {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          this.units[unitIndex].images.push({
            // Store the actual File object
            file: file, 
            preview: URL.createObjectURL(file) 
          });
        }
      }
    },

    removeImage(unitIndex, imgIndex) {
      URL.revokeObjectURL(this.units[unitIndex].images[imgIndex].preview); // Clean up the object URL
      this.units[unitIndex].images.splice(imgIndex, 1);
    },

    async submitSerials() {
      const invalid = this.units.some(u => !u.serialNumber || u.serialNumber.trim() === "");
      if (invalid) {
        notify.warning("All serial numbers must be filled.");
        return;
      }

      // Create a FormData object to send multipart data
      const formData = new FormData();
      
      // Append each unit's data and files with a unique key
      this.units.forEach((unit, index) => {
        // Append product unit data
        formData.append(`units[${index}].id`, unit.id);
        formData.append(`units[${index}].serialNumber`, unit.serialNumber);
        formData.append(`units[${index}].assigned`, true);

        // Append each image file for the unit
        if (unit.images && unit.images.length > 0) {
          unit.images.forEach((image, imgIndex) => {
            formData.append(`units[${index}].images`, image.file, `image_${index}_${imgIndex}.jpg`);
          });
        }
      });
      
      try {
        // You'll need to update your API client to send FormData with the correct headers
        await productApi.updateSerials(formData);
        notify.success("Product units updated successfully!");
        this.units = [];
        this.selectedProductId = '';
      } catch (err) {
        notify.error("Failed to update product units.");
        console.error(err);
      }
    }
  }
};
</script>

<style scoped>
.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.image-thumbnail-container {
  width: 100px;
  height: 100px;
  border: 1px solid #ddd;
  padding: 2px;
  border-radius: 4px;
}

.remove-btn {
  background-color: rgba(220, 53, 69, 0.8);
  border: none;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1.2rem;
  line-height: 1;
}
</style>